import { css } from 'styled-components';

const styles = {
  container: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  `,
  componentContainer: css`
    margin-right: ${({ hasSibling }) => (hasSibling ? '24px' : 0)};
    flex: 1;
  `
};

export default styles;
